import type { TOC } from '@ember/component/template-only'
import type ManageTeachersTeacherRoute from 'teacher-ui-client/manage/teachers/teacher/route'
import { FormEditTeacher } from 'teacher-ui-client/components/form/edit-teacher'
import { usesExternalAuthentication } from 'teacher-ui-client/helpers/uses-external-authentication'
import { usesExternalProvisioning } from 'teacher-ui-client/helpers/uses-external-provisioning'
import RouteTemplate from 'ember-route-template'
import type ManageTeachersTeacherController from './controller'

interface Signature {
  Args: {
    model: ModelFor<ManageTeachersTeacherRoute>
    controller: ManageTeachersTeacherController
  }
}
export const ManageTeachersTeacherPage: TOC<Signature> = <template>
  <FormEditTeacher
    class="m-4"
    @teacher={{@model.teacher}}
    @saveTeacherTask={{@controller.saveTeacherTask}}
    @subscriptionType={{@model.subscriptionType}}
    @usesExternalAuthentication={{(usesExternalAuthentication)}}
    @usesExternalProvisioning={{(usesExternalProvisioning)}}
  />
</template>

export default RouteTemplate(ManageTeachersTeacherPage)
